import pipe from 'lodash/fp/pipe';
import split from 'lodash/fp/split';
import compact from 'lodash/fp/compact';
import map from 'lodash/fp/map';
import first from 'lodash/fp/first';
import upperCase from 'lodash/fp/upperCase';
import join from 'lodash/fp/join';
import RawMuiAvatar from '@mui/material/Avatar';
import { styled } from '@mui/material/styles';
export type AvatarProps = {
  size: 'extraSmall' | 'small' | 'medium' | 'large' | 'extraLarge';
  alt: string;
  image?: string | null;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

const MuiAvatar = styled(RawMuiAvatar)(
  ({ theme }) => `
    backgroundColor: ${theme.palette.blue[60]}
    `,
);

const getCapitalizedFirstLetters = (name: string) => {
  return pipe(split(' '), compact, map(first), map(upperCase), join(''))(name);
};

const Avatar = ({ size, alt, image, onClick }: AvatarProps) => {
  const getSize = (size: string) => {
    switch (size) {
      case 'extraSmall':
        return { width: '24px', height: '24px', fontSize: '12px' };
      case 'small':
        return { width: '32px', height: '32px', fontSize: '16px' };
      case 'large':
        return { width: '60px', height: '60px', fontSize: '18px' };
      case 'extraLarge':
        return { width: '80px', height: '80px', fontSize: '18px' };
      case 'medium':
      default:
        return { width: '40px', height: '40px', fontSize: '18px' };
    }
  };
  return (
    <MuiAvatar
      onClick={onClick ? (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => onClick(e) : undefined}
      alt={alt}
      src={image}
      style={getSize(size)}
      imgProps={{ referrerPolicy: 'no-referrer' }}
    >
      {image === undefined || image === null ? getCapitalizedFirstLetters(alt) : undefined}
    </MuiAvatar>
  ) as React.ReactNode;
};

export default Avatar;
export { Avatar };
